import React, { useState } from 'react';
import { useCart } from '../context/CartContext';
import { API_URL, resolveImageUrl } from '../config';
import './AdminLogin.css';



const AdminLogin = ({ onLoginSuccess }) => {
  const [usernameInput, setUsernameInput] = useState('');
  const [passwordInput, setPasswordInput] = useState('');
  const [loginError, setLoginError] = useState('');
  const [loginLoading, setLoginLoading] = useState(false);
  const { branding } = useCart();

  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    setLoginError('');
    setLoginLoading(true);

    try {
      const response = await fetch(`${API_URL}/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          username: usernameInput,
          password: passwordInput
        })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Failed to authenticate.');
      }

      localStorage.setItem('admin_token', data.token);
      onLoginSuccess();
    } catch (err) {
      console.error(err);
      setLoginError(err.message || 'Connection failed. Please check backend server.');
    } finally {
      setLoginLoading(false);
    }
  };

  return (
    <div className="admin-login-wrapper">
      <div className="login-card">
        <div className="login-logo-wrapper">
          <div className="login-logo-icon">
            <img 
              src={resolveImageUrl(branding.logoUrl)} 
              alt={`${branding.brandName} Logo`} 
              className="login-logo-img" 
            />
          </div>
          <span className="login-logo-title">{branding.brandName}</span>
        </div>

        <h1 className="login-card-title">Admin Dashboard</h1>
        <p className="login-card-subtitle">Secure admin login powered by server-side JWT verification.</p>

        <form onSubmit={handleLoginSubmit} className="login-form">
          <div className="form-group-item">
            <label className="form-label-text">Username</label>
            <input
              type="text"
              className="form-input-field"
              placeholder="Enter admin username"
              value={usernameInput}
              onChange={(e) => setUsernameInput(e.target.value)}
              disabled={loginLoading}
              required
            />
          </div>

          <div className="form-group-item">
            <label className="form-label-text">Password</label>
            <input
              type="password"
              className="form-input-field"
              placeholder="Enter password"
              value={passwordInput}
              onChange={(e) => setPasswordInput(e.target.value)}
              disabled={loginLoading}
              required
            />
          </div>

          {loginError && <div className="login-error-msg">{loginError}</div>}

          <button type="submit" className="login-submit-btn" disabled={loginLoading}>
            <span>{loginLoading ? 'Authenticating...' : 'Secure Login'}</span>
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
